// Prize rows match the artwork: exact regular-ball matches, then Mega Ball.
export const prizeMatches = [
  [5, true],
  [5, false],
  [4, true],
  [4, false],
  [3, true],
  [3, false],
  [2, true],
  [1, true],
  [0, true],
];

const combinations = (n, k) => {
  if (k < 0 || k > n) return 0;
  let result = 1;
  for (let i = 1; i <= Math.min(k, n - k); i += 1) {
    result = (result * (n - i + 1)) / i;
  }
  return result;
};

export const calculateOdds = (ballChoice, megaBallChoice) => {
  const balls = Number(ballChoice);
  const megaBalls = Number(megaBallChoice);
  if (
    !Number.isInteger(balls) ||
    balls < 5 ||
    !Number.isInteger(megaBalls) ||
    megaBalls < 1
  )
    return null;

  const total = combinations(balls, 5) * megaBalls;
  return prizeMatches.map(([matches, mega]) => {
    const winning =
      combinations(5, matches) *
      combinations(balls - 5, 5 - matches) *
      (mega ? 1 : megaBalls - 1);
    return winning ? total / winning : Infinity;
  });
};
